export default "__VITE_ASSET__bdd20ba3__"